export const validationMessagesMappingWithChase = {
  doesNotHaveFormationOrder: {
    modalName: 'non_eligible_no_formation_order',
    header: 'You need to form an LLC through ZenBusiness to apply for banking',
    body: 'Before you can open a ZenBusiness Banking account, you need to form a business through us. Getting started only takes a few minutes.'
  },
  formationOrderIncomplete: {
    modalName: 'non_eligible_formation_incomplete',
    header: 'You need to finish your formation before you can apply for banking',
    body: 'Before you can open a ZenBusiness Banking account, you need to finish giving us the info we need to file your formation with the state.'
  },
  cCorpFormation: {
    modalName: 'non_eligible_c_corp',
    header: 'Since you have a corporation, we suggest Chase for Business.',
    body: 'We’re sorry for the inconvenience. ZenBusiness Banking does not support C-Corps at this time. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  ownedByAnotherbusiness: {
    modalName: 'non_eligible_company_owned_LLC',
    header: 'Since your LLC is company-owned, we suggest Chase for Business.',
    body: 'We’re sorry. ZenBusiness Banking does not support a solution yet for businesses like yours. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  ownerOutstandingJudgment: {
    modalName: 'non_eligible_owner_OJ',
    header: 'Based on your LLC filing, we suggest Chase for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  moreThanOneOwner: {
    modalName: 'non_eligible_multiple_business_entities',
    header: 'Since you have a multi-owner LLC, we suggest Chase for Business.',
    body: 'We’re sorry. ZenBusiness Banking does not support multi-owner LLCs at this time. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  einRestrictions: {
    modalName: 'non_eligible_EIN_restrictions',
    header: 'Based on your LLC filing, we suggest Chase for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  bankingOrderDeclined: {
    modalName: 'non_eligible_banking_order_declined',
    header: 'Based on your LLC filing, we suggest Chase for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  prohibitedBusinessVertical: {
    modalName: 'non_eligible_banking_prohibited_business_vertical',
    header: 'Based on your industry, we suggest Chase for Business.',
    body: 'Based on your industry filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  default: {
    modalName: 'non_eligible_default',
    header: 'Based on your LLC filing, we suggest Chase for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  }
};

export const validationMessagesMappingWithBoAAndBluevine = {
  doesNotHaveFormationOrder: {
    modalName: 'non_eligible_no_formation_order',
    header: 'You need to form an LLC through ZenBusiness to apply for banking',
    body: 'Before you can open a ZenBusiness Banking account, you need to form a business through us. Getting started only takes a few minutes.'
  },
  formationOrderIncomplete: {
    modalName: 'non_eligible_formation_incomplete',
    header: 'You need to finish your formation before you can apply for banking',
    body: 'Before you can open a ZenBusiness Banking account, you need to finish giving us the info we need to file your formation with the state.'
  },
  cCorpFormation: {
    modalName: 'non_eligible_c_corp',
    header: 'Since you have a corporation, we suggest Bank of America and Bluevine for Business.',
    body: 'We’re sorry for the inconvenience. ZenBusiness Banking does not support C-Corps at this time. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  ownedByAnotherbusiness: {
    modalName: 'non_eligible_company_owned_LLC',
    header:
      'Since your LLC is company-owned, we suggest Bank of America and Bluevine for Business.',
    body: 'We’re sorry. ZenBusiness Banking does not support a solution yet for businesses like yours. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  ownerOutstandingJudgment: {
    modalName: 'non_eligible_owner_OJ',
    header: 'Based on your LLC filing, we suggest Bank of America and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  moreThanOneOwner: {
    modalName: 'non_eligible_multiple_business_entities',
    header:
      'Since you have a multi-owner LLC, we suggest Bank of America and Bluevine for Business.',
    body: 'We’re sorry. ZenBusiness Banking does not support multi-owner LLCs at this time. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  einRestrictions: {
    modalName: 'non_eligible_EIN_restrictions',
    header: 'Based on your LLC filing, we suggest Bank of America and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  bankingOrderDeclined: {
    modalName: 'non_eligible_banking_order_declined',
    header: 'Based on your LLC filing, we suggest Bank of America and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  prohibitedBusinessVertical: {
    modalName: 'non_eligible_banking_prohibited_business_vertical',
    header: 'Based on your industry, we suggest Bank of America and Bluevine for Business.',
    body: 'Based on your industry filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  default: {
    modalName: 'non_eligible_default',
    header: 'Based on your LLC filing, we suggest Bank of America and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  }
};

export const validationMessagesMappingWithChaseAndBluevine = {
  doesNotHaveFormationOrder: {
    modalName: 'non_eligible_no_formation_order',
    header: 'You need to form an LLC through ZenBusiness to apply for banking',
    body: 'Before you can open a ZenBusiness Banking account, you need to form a business through us. Getting started only takes a few minutes.'
  },
  formationOrderIncomplete: {
    modalName: 'non_eligible_formation_incomplete',
    header: 'You need to finish your formation before you can apply for banking',
    body: 'Before you can open a ZenBusiness Banking account, you need to finish giving us the info we need to file your formation with the state.'
  },
  cCorpFormation: {
    modalName: 'non_eligible_c_corp',
    header: 'Since you have a corporation, we suggest Chase and Bluevine for Business.',
    body: 'We’re sorry for the inconvenience. ZenBusiness Banking does not support C-Corps at this time. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  ownedByAnotherbusiness: {
    modalName: 'non_eligible_company_owned_LLC',
    header: 'Since your LLC is company-owned, we suggest Chase and Bluevine for Business.',
    body: 'We’re sorry. ZenBusiness Banking does not support a solution yet for businesses like yours. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  ownerOutstandingJudgment: {
    modalName: 'non_eligible_owner_OJ',
    header: 'Based on your LLC filing, we suggest Chase and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  moreThanOneOwner: {
    modalName: 'non_eligible_multiple_business_entities',
    header: 'Since you have a multi-owner LLC, we suggest Chase and Bluevine for Business.',
    body: 'We’re sorry. ZenBusiness Banking does not support multi-owner LLCs at this time. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  einRestrictions: {
    modalName: 'non_eligible_EIN_restrictions',
    header: 'Based on your LLC filing, we suggest Chase and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  bankingOrderDeclined: {
    modalName: 'non_eligible_banking_order_declined',
    header: 'Based on your LLC filing, we suggest Chase and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  prohibitedBusinessVertical: {
    modalName: 'non_eligible_banking_prohibited_business_vertical',
    header: 'Based on your industry, we suggest Chase and Bluevine for Business.',
    body: 'Based on your industry filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  },
  default: {
    modalName: 'non_eligible_default',
    header: 'Based on your LLC filing, we suggest Chase and Bluevine for Business.',
    body: 'Based on your LLC filing, you cannot apply for a ZenBusiness Banking account. We’re sorry. Consider our partner bank for your account.',
    url: 'https://click.linksynergy.com/fs-bin/click?id=A%2fHiQlD3Yhw&offerid=1883754.161&type=3&subid=0'
  }
};

export const BANKING_ELIGIBILITY_STATUS = {
  DOES_NOT_HAVE_FORMATION_ORDER: 'doesNotHaveFormationOrder',
  FORMATION_ORDER_INCOMPLETE: 'formationOrderIncomplete',
  C_CORP_FORMATION: 'cCorpFormation',
  OWNED_BY_ANOTHER_BUSINESS: 'ownedByAnotherbusiness',
  OWNER_OUTSTANDING_JUDGMENT: 'ownerOutstandingJudgment',
  MORE_THAN_ONE_OWNER: 'moreThanOneOwner',
  EIN_RESTRICTIONS: 'einRestrictions',
  BANKING_ORDER_DECLINED: 'bankingOrderDeclined',
  PROHIBITED_BUSINESS_VERTICAL: 'prohibitedBusinessVertical',
  BANKING_WIND_DOWN: 'bankingWindDown',
  ELIGIBLE: 'eligible',
  DEFAULT: 'default'
};
